module.exports = __webpack_public_path__ + "img/Icone_logo.c91df1f9.png";